import { render, staticRenderFns } from "./mapdata.vue?vue&type=template&id=0ca4030c&scoped=true&"
import script from "./mapdata.vue?vue&type=script&lang=js&"
export * from "./mapdata.vue?vue&type=script&lang=js&"
import style0 from "./mapdata.vue?vue&type=style&index=0&id=0ca4030c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca4030c",
  null
  
)

export default component.exports